const PREFIX = 'posmCallLog';

const browserStorage = {
  // localStorage
  localStorageSet(key, data) {
    localStorage.setItem(`${PREFIX}.${key}`, JSON.stringify(data));
  },
  localStorageGet(key, defaultValue) {
    let data = localStorage.getItem(`${PREFIX}.${key}`);

    if (data) {
      try {
        data = JSON.parse(data);
      } catch {
        data = defaultValue;
      }
    } else {
      data = defaultValue;
    }

    return data;
  },
  localStorageDelete(key) {
    localStorage.removeItem(`${PREFIX}.${key}`);
  },
  localStorageClear() {
    localStorage.clear();
  },

  // sessionStorage
  sessionStorageSet(key, data) {
    sessionStorage.setItem(`${PREFIX}.${key}`, JSON.stringify(data));
  },
  sessionStorageGet(key, defaultValue) {
    let data = sessionStorage.getItem(`${PREFIX}.${key}`);

    if (data) {
      try {
        data = JSON.parse(data);
      } catch {
        data = defaultValue;
      }
    } else {
      data = defaultValue;
    }

    return data;
  },
  sessionStorageDelete(key) {
    sessionStorage.removeItem(`${PREFIX}.${key}`);
  },
  sessionStorageClear() {
    sessionStorage.clear();
  },
};

const browserStorageMixin = {
  methods: browserStorage,
};

export {
  browserStorage,
  browserStorageMixin,
};
